import globalAxios, { AxiosInstance } from 'axios';
import {
  CodeApi,
  InvestigationApi,
  TimeEntryApi,
  TrustTeamMemberApi,
  SyncHistoryApi,
  CalendarApi,
  BreachApi,
  SystemApi,
  AccountAppApi,
  ConfigTrustApi,
  StatutoryDepositApi,
  ReportApi,
  ComplianceFormApi,
} from '../typescript-trust-ti-api-client/api';
import { AccountApi } from '../typescript-trust-ti-api-client/apis/account-api';
import { NotesApi } from '../typescript-trust-ti-api-client/apis/notes-api';
import { PracticeApi } from '../typescript-trust-ti-api-client/apis/practice-api';
import { Configuration } from '../typescript-trust-ti-api-client/configuration';
import { PeopleApi } from '../typescript-trust-ti-api-client/apis/people-api';
import { CorrespondenceApi } from '../typescript-trust-ti-api-client/apis/correspondence-api';

import { AccountApi as AccountApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { AccountingAppApi as AccountAppApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { BreachApi as BreachApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { CalendarApi as CalendarApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { CodeApi as CodeApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { ComplianceFormApi as ComplianceFormApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { ConfigTrustApi as ConfigTrustApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { CorrespondenceApi as CorrespondenceApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { InvestigationApi as InvestigationApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { NotesApi as NotesApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { PeopleApi as PeopleApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { PracticeApi as PracticeApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { StatutoryDepositApi as StatutoryDepositApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { ReportApi as ReportApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { SyncApi as SyncApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { SystemApi as SystemApiV2 } from '../typescript-trust-ti-api-client-v2/api';
import { TimeEntryApi as TimeEntryApiV2 } from '../typescript-trust-ti-api-client-v2/api';

export const BASE_PATH = '/'.replace(/\/+$/, '');

export class TrustTIAPI {
  public CodeApi?: CodeApi;
  public InvestigationApi?: InvestigationApi;
  public TimeEntryApi?: TimeEntryApi;
  public TrustTeamMemberApi?: TrustTeamMemberApi;
  public SyncHistoryApi?: SyncHistoryApi;
  public CalendarApi?: CalendarApi;
  public PracticeApi?: PracticeApi;
  public NotesApi?: NotesApi;
  public AccountApi?: AccountApi;
  public PeopleApi?: PeopleApi;
  public CorrespondenceApi?: CorrespondenceApi;
  public SystemApi?: SystemApi;
  public BreachApi?: BreachApi;
  public AccountAppApi?: AccountAppApi;
  public ConfigTrustApi?: ConfigTrustApi;
  public StatutoryDepositApi?: StatutoryDepositApi;
  public ReportApi?: ReportApi;
  public ComplianceFormApi?: ComplianceFormApi;

  public AccountApiV2?: AccountApiV2;
  public AccountAppApiV2?: AccountAppApiV2;
  public BreachApiV2?: BreachApiV2;
  public CalendarApiV2?: CalendarApiV2;
  public CodeApiV2?: CodeApiV2;
  public ComplianceFormApiV2?: ComplianceFormApiV2;
  public ConfigTrustApiV2?: ConfigTrustApiV2;
  public CorrespondenceApiV2?: CorrespondenceApiV2;
  public InvestigationApiV2?: InvestigationApiV2;
  public NotesApiV2?: NotesApiV2;
  public PeopleApiV2?: PeopleApiV2;
  public PracticeApiV2?: PracticeApiV2;
  public ReportApiV2?: ReportApiV2;
  public StatutoryDepositApiV2?: StatutoryDepositApiV2;
  public SyncApiV2?: SyncApiV2;
  public SystemApiV2?: SystemApiV2;
  public TimeEntryApiV2?: TimeEntryApiV2;

  constructor(
    configuration?: Configuration,
    protected basePath: string = BASE_PATH,
    protected axios: AxiosInstance = globalAxios,
  ) {
    this.CodeApi = new CodeApi(configuration, basePath, axios);
    this.InvestigationApi = new InvestigationApi(configuration, basePath, axios);
    this.TimeEntryApi = new TimeEntryApi(configuration, basePath, axios);
    this.TrustTeamMemberApi = new TrustTeamMemberApi(configuration, basePath, axios);
    this.SyncHistoryApi = new SyncHistoryApi(configuration, basePath, axios);
    this.CalendarApi = new CalendarApi(configuration, basePath, axios);
    this.PracticeApi = new PracticeApi(configuration, basePath, axios);
    this.NotesApi = new NotesApi(configuration, basePath, axios);
    this.AccountApi = new AccountApi(configuration, basePath, axios);
    this.PeopleApi = new PeopleApi(configuration, basePath, axios);
    this.CorrespondenceApi = new CorrespondenceApi(configuration, basePath, axios);
    this.SystemApi = new SystemApi(configuration, basePath, axios);
    this.BreachApi = new BreachApi(configuration, basePath, axios);
    this.AccountAppApi = new AccountAppApi(configuration, basePath, axios);
    this.ConfigTrustApi = new ConfigTrustApi(configuration, basePath, axios);
    this.StatutoryDepositApi = new StatutoryDepositApi(configuration, basePath, axios);
    this.ReportApi = new ReportApi(configuration, basePath, axios);
    this.ComplianceFormApi = new ComplianceFormApi(configuration, basePath, axios);

    this.AccountApiV2 = new AccountApiV2(configuration, basePath, axios);
    this.AccountAppApiV2 = new AccountAppApiV2(configuration, basePath, axios);
    this.BreachApiV2 = new BreachApiV2(configuration, basePath, axios);
    this.CalendarApiV2 = new CalendarApiV2(configuration, basePath, axios);
    this.CodeApiV2 = new CodeApiV2(configuration, basePath, axios);
    this.ComplianceFormApiV2 = new ComplianceFormApiV2(configuration, basePath, axios);
    this.ConfigTrustApiV2 = new ConfigTrustApiV2(configuration, basePath, axios);
    this.CorrespondenceApiV2 = new CorrespondenceApiV2(configuration, basePath, axios);
    this.InvestigationApiV2 = new InvestigationApiV2(configuration, basePath, axios);
    this.NotesApiV2 = new NotesApiV2(configuration, basePath, axios);
    this.PeopleApiV2 = new PeopleApiV2(configuration, basePath, axios);
    this.PracticeApiV2 = new PracticeApiV2(configuration, basePath, axios);
    this.ReportApiV2 = new ReportApiV2(configuration, basePath, axios);
    this.StatutoryDepositApiV2 = new StatutoryDepositApiV2(configuration, basePath, axios);
    this.SyncApiV2 = new SyncApiV2(configuration, basePath, axios);
    this.SystemApiV2 = new SystemApiV2(configuration, basePath, axios);
    this.TimeEntryApiV2 = new TimeEntryApiV2(configuration, basePath, axios);
  }
}
